import './App.css';
import Launcher from './components/Launcher';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'jotai';
import React from 'preact/compat';

import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import './fonts.css';

let theme = createTheme({
    typography: {
        fontFamily: [
            '"Oracle Sans"', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', '"Roboto"', '"Oxygen"',
            '"Ubuntu"', '"Cantarell"', '"Fira Sans"', '"Droid Sans"', '"Helvetica Neue"', 'sans-serif'
        ].join(',')
    }
});

let appName;
if (process.env.REACT_APP_GRAALOS) {
    appName = 'GRAALOS';
} else {
    appName = 'GDK';
}

function App() {
    document.title = appName + " Launcher";
    return (
    <Provider>
        <Box className="App">
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <Launcher appName={appName}/>
                </BrowserRouter>
            </ThemeProvider>
        </Box>
    </Provider>
    );
}

export default App;
